module.exports = __webpack_public_path__ + "img/comp.e9438d55.png";